<template>
  <div :id="componentId" :style="offsetVars" class="user-filter" :class="{ 'user-filter--nested': nested }">
    <!-- Web'de `inline`: AppModal yerinde render eder, body scroll kilidi /
         ESC / history kaydi devreye girmez (AppModal.vue:193). Boylece panel
         sayfayla birlikte kayar. `v-if` sart: inline modda AppModal kendi
         `visible`ina bakmaz, hep gorunur. -->
    <AppModal v-if="!isDropdownMode || panelOpen"
              :close-on-overlay="nested || !isMobile"
              :inline="isDropdownMode"
              :max-height="filterModalMaxHeight"
              :nested="nested"
              :show-close-button="!isDropdownMode"
              :title="isDropdownMode ? '' : $t('general.filter_list')"
              :visible.sync="panelOpen"
              :width="filterModalWidth"
              @close="closePanel"
    >
      <div class="user-filter-panel">
        <div class="filter-container">
          <div class="user-filter-grid uk-child-width-1-2@s uk-grid-small" uk-grid>

        <div v-if="!reportAssignment && superAdmin()">
          <h5 class="uk-text-bold mb-2"> {{ $t('users.institution') }}</h5>
          <multiselect v-model="filter.company_id" :allow-empty="false" :clear-on-select="false"
                       :deselectLabel="$t('general.deselect')" :multiple="false" :options="formattedInstitution"
                       :placeholder="$t('general.select')" :preserve-search="true" :searchable="true"
                       :selectLabel="$t('general.select')" :selectedLabel="$t('general.selected')"
                       :tag-placeholder="$t('general.select')" label="name" track-by="id"
                       @input="changeCompany($event)">
            <template slot="option" slot-scope="option">
              {{ option.option.name }}
            </template>
          </multiselect>
        </div>

        <div v-if="reportAssignment">
          <h5 class="uk-text-bold mb-2">{{ $t('general.assignments') }}</h5>
          <multiselect v-model="assignment_id" :allow-empty="true" :clear-on-select="false" :close-on-select="false"
                       :deselectLabel="$t('general.deselect')" :max-height="600" :multiple="true"
                       :options="filteredAssignmentList"
                       :placeholder="$t('general.select')" :preserve-search="true" :searchable="true"
                       :selectLabel="$t('general.select')" :selectedLabel="$t('general.selected')"
                       :tag-placeholder="$t('general.select')" label="name" track-by="id">
            <template slot="tag" slot-scope="{ option, remove }">
              <span class="multiselect__tag">
                <span>
                  {{ option.name }}
                  <strong v-if="option.status_id === 1">({{ $t('general.active') }})</strong>
                  <strong v-else-if="option.status_id === 0">({{ $t('general.passive') }})</strong>
                </span>
                <i aria-hidden="true" class="multiselect__tag-icon" tabindex="1" @click="remove(option)"
                   @keypress.enter.prevent="remove(option)"/>
              </span>
            </template>
            <template slot="option" slot-scope="option">
              {{ option.option.name }}
              <strong v-if="option.option.status_id === 1">({{ $t('general.active') }})</strong>
              <strong v-else-if="option.option.status_id === 0">({{ $t('general.passive') }})</strong>
            </template>
          </multiselect>
        </div>
        <div v-if="reportSurvey">
          <h5 class="uk-text-bold mb-2">{{ $t('general.assignments') }}</h5>
          <app-multiselect v-model="surveyId" :allow-empty="true" :disabled="surveyLoading"
                           :is-multiple="true"
                           :options="surveyLoading ? [] : surveyList"
                           :placeholder="surveyLoading ? $t('general.loading') + '...' : $t('general.assignments')"
                           label="name"/>
          <!-- <multiselect v-model="surveyId" :allow-empty="true" :clear-on-select="false" :close-on-select="false"
                       :deselectLabel="$t('general.deselect')" :max-height="600" :multiple="false" :options="surveyList"
                       :placeholder="$t('general.select')" :preserve-search="true" :searchable="true"
                       :selectLabel="$t('general.select')" :selectedLabel="$t('general.selected')"
                       :tag-placeholder="$t('general.select')" label="name" track-by="id">
            <template slot="option" slot-scope="option">
              {{ option.option.name }}
            </template>
          </multiselect> -->
        </div>

        <div v-if="isUserActive">
          <h5 class="uk-text-bold mb-2">{{ $t('general.user') }}</h5>
          <app-multiselect v-model="user_ids" :allow-empty="true" :disabled="assignmentLoading" :is-multiple="true"
                           :options="assignmentLoading ? [] : userList"
                           :placeholder="assignmentLoading ? $t('general.loading') + '...' : $t('general.select_user')"
                           label="name"/>
        </div>

        <div v-if="showContentFilter">
          <h5 class="uk-text-bold mb-2">{{ $t('general.contents') }}</h5>
          <app-multiselect v-model="content_ids" :allow-empty="true" :disabled="contentLoading" :is-multiple="true"
                           :options="contentList"
                           :placeholder="contentLoading ? $t('general.loading') + '...' : $t('general.select')"
                           label="name"/>
        </div>

        <div v-if="showContentTypeFilter">
          <h5 class="uk-text-bold mb-2">{{ $t('general.content_type') }}</h5>
          <app-multiselect v-model="file_category_ids" :allow-empty="true" :is-multiple="true"
                           :options="contentTypeOptions" :placeholder="$t('general.select')" label="name"/>
        </div>

        <div v-if="isCatalogActive">
          <h5 class="uk-text-bold mb-2"> {{ $t('general.catalog_trainings') }} </h5>
          <multiselect v-model="training_id" :allow-empty="true" :clear-on-select="false" :close-on-select="false"
                       :deselectLabel="$t('general.deselect')" :max-height="600" :multiple="true"
                       :options="formattedCatalogs"
                       :placeholder="$t('general.select')" :preserve-search="true" :searchable="true"
                       :selectLabel="$t('general.select')" :selectedLabel="$t('general.selected')"
                       :tag-placeholder="$t('general.select')" label="name" track-by="id">
            <template slot="option" slot-scope="option">
              {{ option.option.name }}
            </template>
          </multiselect>
        </div>

        <div>
          <h5 class="uk-text-bold mb-2">{{ $t('users.mission') }}</h5>
          <multiselect v-model="filter.position_id" :allow-empty="true" :clear-on-select="false"
                       :close-on-select="false"
                       :deselectLabel="$t('general.deselect')" :multiple="true" :options="formattedPosition"
                       :placeholder="$t('general.select')" :preserve-search="true" :searchable="true"
                       :selectLabel="$t('general.select')" :selectedLabel="$t('general.selected')"
                       :tag-placeholder="$t('general.select')" label="name" track-by="id">
            <template slot="option" slot-scope="option">
              {{ option.option.name }}
            </template>
          </multiselect>
        </div>

        <div>
          <h5 class="uk-text-bold mb-2">{{ $t('users.title') }} </h5>
          <multiselect v-model="filter.title_id" :allow-empty="true" :clear-on-select="false" :close-on-select="false"
                       :deselectLabel="$t('general.deselect')" :multiple="true" :options="formattedTitle"
                       :placeholder="$t('general.select')" :preserve-search="true" :searchable="true"
                       :selectLabel="$t('general.select')" :selectedLabel="$t('general.selected')"
                       :tag-placeholder="$t('general.select')" label="name" track-by="id">
            <template slot="option" slot-scope="option">
              {{ option.option.name }}
            </template>
          </multiselect>
        </div>

        <div>
          <h5 class="uk-text-bold mb-2">{{ $t('users.area') }}</h5>
          <multiselect v-model="filter.region_id" :allow-empty="true" :clear-on-select="false" :close-on-select="false"
                       :deselectLabel="$t('general.deselect')" :multiple="true" :options="formattedRegion"
                       :placeholder="$t('general.select')" :preserve-search="true" :searchable="true"
                       :selectLabel="$t('general.select')" :selectedLabel="$t('general.selected')"
                       :tag-placeholder="$t('general.select')" label="name" track-by="id">
            <template slot="option" slot-scope="option">
              {{ option.option.name }}
            </template>
          </multiselect>
        </div>

        <div>
          <h5 class="uk-text-bold mb-2"> {{ $t('users.department') }}</h5>
          <multiselect v-model="filter.department_id" :allow-empty="true" :clear-on-select="false"
                       :close-on-select="false" :deselectLabel="$t('general.deselect')" :multiple="true"
                       :options="formattedDepartment" :placeholder="$t('general.select')" :preserve-search="true"
                       :searchable="true"
                       :selectLabel="$t('general.select')" :selectedLabel="$t('general.selected')"
                       :tag-placeholder="$t('general.select')" label="name" track-by="id">
            <template slot="option" slot-scope="option">
              {{ option.option.name }}
            </template>
          </multiselect>
        </div>

        <div v-if="$hasPermission('read_branch')">
          <h5 class="uk-text-bold mb-2"> {{ $t('users.branch') }} </h5>
          <multiselect v-model="filter.branch_id" :allow-empty="true" :clear-on-select="false" :close-on-select="false"
                       :deselectLabel="$t('general.deselect')" :multiple="true" :options="formattedBranch"
                       :placeholder="$t('general.select')" :preserve-search="true" :searchable="true"
                       :selectLabel="$t('general.select')" :selectedLabel="$t('general.selected')"
                       :tag-placeholder="$t('general.select')" label="name" track-by="id">
            <template slot="option" slot-scope="option">
              {{ option.option.name }}
            </template>
          </multiselect>
        </div>

        <!-- Şirket seçimi: atanmış kullanıcı için CorporateSelect kendi içinde kilitler -->
        <div>
          <h5 class="uk-text-bold mb-2"> {{ $t('general.corporate') }} </h5>
          <CorporateSelect v-model="filter.corporate_id"
                           :company-id="filter.company_id ? filter.company_id.id : userInfo.company_id"
                           :prefill-from-self="true"/>
        </div>

        <div v-if="hasCompetency">
          <h5 class="uk-text-bold mb-2"> {{ $t('general.competencies') }} </h5>
          <CompetenciesInputSelection v-model="filter.competency_id"/>
        </div>
        <div>
          <h5 class="uk-text-bold mb-2"> {{ $t('general.group') }}</h5>
          <multiselect v-model="filter.group_id" :allow-empty="true" :clear-on-select="false" :close-on-select="false"
                       :deselectLabel="$t('general.deselect')" :multiple="true" :options="formattedGroup"
                       :placeholder="$t('general.select')" :preserve-search="true" :searchable="true"
                       :selectLabel="$t('general.select')" :selectedLabel="$t('general.selected')"
                       :tag-placeholder="$t('general.select')" label="name" track-by="id">
            <template slot="option" slot-scope="option">
              {{ option.option.name }}
            </template>
          </multiselect>
        </div>
        <div v-if="showIntegrationFilter">
          <h5 class="uk-text-bold mb-2">{{ $t('general.integrations') }}</h5>
          <multiselect v-model="filter.integration_tags" :allow-empty="true" :clear-on-select="false"
                       :close-on-select="false" :deselectLabel="$t('general.deselect')" :multiple="true"
                       :options="integrationOptions" :placeholder="$t('general.select')" :preserve-search="true"
                       :searchable="true" :selectLabel="$t('general.select')" :selectedLabel="$t('general.selected')"
                       :tag-placeholder="$t('general.select')" label="name" track-by="id">
            <template slot="option" slot-scope="option">
              {{ option.option.name }}
            </template>
          </multiselect>
        </div>
        <div v-if="showRoleFilter">
          <h5 class="uk-text-bold mb-2">{{ $t('excel.heading.roles') }}</h5>
          <multiselect v-model="filter.role_ids" :allow-empty="true" :clear-on-select="false"
                       :close-on-select="false" :deselectLabel="$t('general.deselect')" :multiple="true"
                       :options="roleOptions" :placeholder="$t('general.select')" :preserve-search="true"
                       :searchable="true" :selectLabel="$t('general.select')" :selectedLabel="$t('general.selected')"
                       :tag-placeholder="$t('general.select')" label="name" track-by="id">
            <template slot="option" slot-scope="option">
              {{ option.option.name }}
            </template>
          </multiselect>
        </div>
        <div v-if="isDate" class="user-filter-date">
          <AppDatePicker v-model="selectedDate" :label="$t('general.date')" :show-presets="true" :show-time="false"
                         mode="range" :panel-position="isMobile ? 'bottom' : 'top'"/>
        </div>
        <div v-if="showProviderTrainingFilter">
          <h5 class="uk-text-bold mb-2">{{ $t('report.provider_trainings') }}</h5>
          <multiselect v-model="filter.provider" :allow-empty="true" :clear-on-select="false" :close-on-select="true"
                       :deselectLabel="$t('general.deselect')" :multiple="false" :options="providerTrainingOptions"
                       :placeholder="$t('general.select')" :preserve-search="true" :searchable="true"
                       :selectLabel="$t('general.select')" :selectedLabel="$t('general.selected')"
                       :tag-placeholder="$t('general.select')" label="name" track-by="id">
            <template slot="option" slot-scope="option">
              {{ option.option.name }}
            </template>
          </multiselect>
        </div>
        <div v-if="show_only_unassigned_users">
          <label for="show_only_unassigned_users">
            {{ $t('assignment.show_only_unassigned_users') }}
            <i :uk-tooltip="$t('assignment.notAssigned')" class="uil-info-circle"/>
          </label>
          <label class="uk-switch" for="show_only_unassigned_users">
            <input id="show_only_unassigned_users" v-model="filter.show_only_unassigned_users" type="checkbox"/>
            <div class="uk-switch-slider"/>
          </label>
        </div>

        <div v-if="reportAssignment">
          <UserStatusFilter v-model="assignmentStatusFilter" :label="$t('general.assignment_edu_status')"/>
        </div>

        <div v-if="hasStatus">
          <UserStatusFilter v-model="filter.user_status"/>
        </div>

      </div>
        </div>
      </div>
      <template #footer>
        <button class="btn btn-light" type="button" @click="resetFilter()">
          {{ $t('general.clear_all') }}
        </button>
        <button class="btn btn-primary grey" type="button" @click="submitFilter">
          <i class="uil-filter"></i>
          {{ $t('general.filter') }}
        </button>
      </template>
    </AppModal>
  </div>
</template>

<script>
import store from '@/core/services'
import MultipleSelectInput from "@/assets/components/inputs/MultipleSelectInput";
import company_module, {
  BASE_URL as COMPANY_BASE_URL,
  GET_ITEMS as GET_INSTITUTIONS,
  ITEMS as INSTITUTIONS,
  MODULE_NAME as COMPANY_MODULE,
} from "@/core/services/store/company.module";

import position_module, {
  BASE_URL as POSITION_BASE_URL,
  GET_ITEMS as GET_POSITIONS,
  ITEMS as POSITIONS,
  MODULE_NAME as POSITION_MODULE,
} from "@/core/services/store/position.module";

import title_module, {
  BASE_URL as TITLE_BASE_URL,
  GET_ITEMS as GET_TITLES,
  ITEMS as TITLES,
  MODULE_NAME as TITLE_MODULE,
} from "@/core/services/store/title.module";

import region_module, {
  BASE_URL as REGION_BASE_URL,
  GET_ITEMS as GET_REGIONS,
  ITEMS as REGIONS,
  MODULE_NAME as REGION_MODULE,
} from "@/core/services/store/region.module";

import department_module, {
  BASE_URL as DEPARTMENT_BASE_URL,
  GET_ITEMS as GET_DEPARTMENTS,
  ITEMS as DEPARTMENTS,
  MODULE_NAME as DEPARTMENT_MODULE,
} from "@/core/services/store/department.module";

import branch_module, {
  BASE_URL as BRANCH_BASE_URL,
  GET_ITEMS as GET_BRANCHES,
  ITEMS as BRANCHES,
  MODULE_NAME as BRANCH_MODULE,
} from "@/core/services/store/branch.module";

import { GET_ITEMS as GET_CATALOG_ITEMS } from "@/core/services/store/REST.module";
import CorporateSelect from "@/view/components/select/CorporateSelect.vue";
import UserStatusFilter from './components/UserStatusFilter.vue';
import AppMultiselect from "@/view/components/select/app-multiselect/app-multiselect.vue";
import CompetenciesInputSelection from "@/view/components/input/CompetenciesInputSelection.vue";
import AppDatePicker from "@/view/components/ui/AppDatePicker.vue";
import AppModal from "@/view/components/ui/AppModal.vue";
import group_module, {
  GET_ITEMS as GET_GROUPS,
  ITEMS as GROUP_ITEMS,
  MODULE_NAME as GROUP_MODULE,
} from "@/core/services/store/user_group.module";
import { CONTENT_TYPES } from "@/core/constant/content-types";
import axios from "axios";

const _COMPANY_MODULE_NAME = COMPANY_MODULE;
const _POSITION_MODULE = POSITION_MODULE;
const _TITLE_MODULE = TITLE_MODULE;
const _REGION_MODULE = REGION_MODULE;
const _DEPARTMENT_MODULE = DEPARTMENT_MODULE;
const _BRANCH_MODULE = BRANCH_MODULE;
const _GROUP_MODULE = GROUP_MODULE;
export default {
  name: "UserFilter",
  components: {
    CompetenciesInputSelection,
    AppMultiselect,
    MultipleSelectInput,
    UserStatusFilter,
    CorporateSelect,
    AppDatePicker,
    AppModal,
  },
  props: {
    show_only_unassigned_users: false,
    reportAssignment: null,
    reportSurvey: null,
    surveyList: [],
    assignmentList: [],
    isDate: {
      required: false,
      default: true,
    },
    isCatalogActive: {
      type: Boolean,
      default: false,
    },
    showContentFilter: {
      type: Boolean,
      default: false,
    },
    showContentTypeFilter: {
      type: Boolean,
      default: false,
    },
    contentList: {
      type: Array,
      default: () => [],
    },
    contentLoading: {
      type: Boolean,
      default: false,
    },
    surveyLoading: {
      type: Boolean,
      default: false,
    },
    hasStatus: {
      type: Boolean,
      default: false,
    },
    hasCompetency: {
      type: Boolean,
      default: false,
    },
    isUserActive: {
      type: Boolean,
      default: false,
    },
    showProviderTrainingFilter: {
      type: Boolean,
      default: false,
    },
    nested: {
      type: Boolean,
      default: false,
    },
    showIntegrationFilter: {
      type: Boolean,
      default: false,
    },
    showRoleFilter: {
      type: Boolean,
      default: false,
    },
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule)
      }
    }

    registerStoreModule(_GROUP_MODULE, group_module);
    registerStoreModule(_COMPANY_MODULE_NAME, company_module)
    registerStoreModule(_POSITION_MODULE, position_module)
    registerStoreModule(_TITLE_MODULE, title_module)
    registerStoreModule(_REGION_MODULE, region_module)
    registerStoreModule(_DEPARTMENT_MODULE, department_module)
    registerStoreModule(_BRANCH_MODULE, branch_module)
  },
  data() {
    return {
      selectedDate: (() => {
        const end = new Date();
        const start = new Date();
        start.setDate(start.getDate() - 7);
        const fmt = (d) => {
          const y = d.getFullYear();
          const m = String(d.getMonth() + 1).padStart(2, '0');
          const day = String(d.getDate()).padStart(2, '0');
          return `${y}-${m}-${day}`;
        };
        return { start: fmt(start), end: fmt(end) };
      })(),
      componentId: window.location.href.split('#/')[1],
      panelOpen: false,
      // Panelin capaya gore kaymasi. Ikon ile capanin DOM'daki iliskisi
      // sayfadan sayfaya degistigi icin CSS'ten cikarilamiyor.
      offsetTop: 0,
      offsetRight: 0,
      isMobile: false,
      filter: {
        company_id: null,
        // branch_id: null,
        // department_id: null,
        // region_id: null,
        // title_id: null,
        // position_id: null,
        title_id: [],
        position_id: [],
        branch_id: [],
        assignment_id: [],
        region_id: [],
        department_id: [],
        corporate_id: [],
        competency_id: [],
        provider: null,
        show_only_unassigned_users: false,
        user_status: 1,
        group_id: [],
        integration_tags: [],
        role_ids: []
      },
      content_ids: [],
      file_category_ids: [],
      assignment_id: [],
      user_ids: [],
      trainingUrl: "api/training/",
      training_id: [], // katalog eğitimleri
      formattedCatalogs: [], // katalog eğitimleri
      userList: [],
      assignmentLoading: false,
      assignmentStatusFilter: 1,
      surveyId: null,
      userLoading: false,
      userRequestKey: 0,
      integrationOptions: [],
      roleOptions: [],
      providerTrainingOptions: [
        { id: 'linkedin', name: 'LinkedIn Learning' },
        { id: 'udemy', name: 'Udemy Business' },
        { id: 'harvard-business', name: 'Harvard Business' },
        { id: 'aeroclass', name: 'Aeroclass' },
      ],
    }
  },
  computed: {
    // Custom property'ler scoped sinirini gecerek miras alinir
    offsetVars() {
      return {
        "--filter-offset-top": `${this.offsetTop}px`,
        "--filter-offset-right": `${this.offsetRight}px`,
      };
    },
    isDropdownMode() {
      return !this.isMobile && !this.nested;
    },
    filterModalWidth() {
      if (this.nested) {
        return this.isMobile ? "calc(100% - 32px)" : "720px";
      }
      if (this.isMobile) {
        return "100%";
      }
      // Dar ekranlarda ikonun altinda tasmasin
      return "min(720px, calc(100vw - 32px))";
    },
    filterModalMaxHeight() {
      if (this.nested) {
        return this.isMobile ? "85vh" : "80vh";
      }
      if (this.isMobile) {
        return "100%";
      }
      // Dropdown modda ic kaydirma YOK: multiselect listeleri panelden
      // tasabilsin diye yukseklik icerige birakiliyor.
      return "";
    },
    contentTypeOptions() {
      return CONTENT_TYPES.map((item) => ({
        id: item.id,
        name: this.$t(item.key_name),
      }));
    },

    branches: {
      get() {
        return store.getters[BRANCH_MODULE + "/" + BRANCHES];
      },
      set(value) {
      },
    },
    groups: {
      get() {
        return store.getters[GROUP_MODULE + "/" + GROUP_ITEMS];
      },
      set(value) {
      },
    },
    departments: {
      get() {
        return store.getters[DEPARTMENT_MODULE + "/" + DEPARTMENTS];
      },
      set(value) {
      },
    },
    regions: {
      get() {
        return store.getters[REGION_MODULE + "/" + REGIONS];
      },
      set(value) {
      },
    },
    titles: {
      get() {
        return store.getters[TITLE_MODULE + "/" + TITLES];
      },
      set(value) {
      },
    },
    positions: {
      get() {
        return store.getters[POSITION_MODULE + "/" + POSITIONS];
      },
      set(value) {
      },
    },
    institutions: {
      get() {
        return store.getters[COMPANY_MODULE + "/" + INSTITUTIONS];
      },
      set(value) {
      },
    },
    filteredAssignmentList() {
      const list = this.assignmentList || [];
      if (!this.$route || this.$route.path !== "/admin/reports/user-assignments") {
        return list;
      }

      const filtered = this.assignmentStatusFilter === null
          ? list
          : list.filter(item => item.id == null || item.status_id === this.assignmentStatusFilter)
      // Önceden seçilmiş atamalar filtreden düşse bile options'ta kalsın
      const selected = this.assignment_id || [];
      const extra = selected.filter(
          sel => sel && !filtered.some(item => item.id === sel.id)
      )
      return extra.length ? [...filtered, ...extra] : filtered;
    },

    formattedBranch() {
      let results = [];
      if (this.branches === null || !this.branches instanceof Array) return [];

      this.branches.forEach((item) => {
        results.push({
          id: item.id,
          name: item.name,
        });
      });
      return results;
    },
    formattedGroup() {
      let groups = [];

      if (Array.isArray(this.groups)) {
        groups = this.groups;
      } else if (Array.isArray(this.groups?.data)) {
        groups = this.groups.data;
      } else {
        return [];
      }

      return groups.map(({ id, name }) => ({
        id,
        name,
      }));
    },
    formattedDepartment() {
      let results = [];
      if (this.departments === null || !this.departments instanceof Array) return [];

      this.departments.forEach((item) => {
        results.push({
          id: item.id,
          name: item.name,
        });
      });
      return results;
    },
    formattedRegion() {
      let results = [];
      if (this.regions === null || !this.regions instanceof Array) return [];

      this.regions.forEach((item) => {
        results.push({
          id: item.id,
          name: item.name,
        });
      });
      return results;
    },
    formattedInstitution() {
      let results = [];
      if (this.institutions === null || !Array.isArray(this.institutions)) return [];
      this.institutions.forEach((item) => {
        results.push({
          id: item.id,
          name: item.name,
        });
      });
      return results;
    },
    formattedPosition() {
      let positions = [];
      if (this.positions === null || !this.positions instanceof Array) return [];

      this.positions.forEach((item) => {
        positions.push({
          id: item.id,
          name: item.name,
        });
      });
      return positions;
    },
    formattedTitle() {
      let titles = [];
      if (this.titles === null || !this.titles instanceof Array) return [];

      this.titles.forEach((item) => {
        titles.push({
          id: item.id,
          name: item.name,
        });
      });
      return titles;
    },
    userInfo: {
      get: function () {
        return JSON.parse(this.secureLocalStorage("user"));
      },
      set: function (newValue) {
      },
    },
    user_header: {
      get() {
        return JSON.parse(this.secureLocalStorage("user"));
      },
      set() {
      },
    },
  },
  methods: {
    updateIsMobile() {
      this.isMobile = typeof window !== "undefined" && window.innerWidth <= 767;
    },
    onViewportResize() {
      this.updateIsMobile();
      this.updateOffset();
    },
    /**
     * Panel konumu, IKON ile CAPA (.user-filter) arasindaki FARK olarak
     * hesaplanir; mutlak ekran koordinati kullanilmaz.
     *
     * Neden fark: capa `position: absolute` ve flex kapsayici icinde, o
     * yuzden statik konumu DOM sirasi degil kapsayicinin kosesi oluyor —
     * ikonun neresinde duracagi sayfadan sayfaya degisiyor. Fark ise her
     * sayfada dogru sonucu verir ve iki eleman ayni scroll baglaminda
     * oldugu icin kaydirmadan etkilenmez (scroll dinleyicisi gerekmez).
     */
    updateOffset() {
      if (!this.isDropdownMode || !this.toggleEl || !this.$el) {
        return;
      }
      const toggle = this.toggleEl.getBoundingClientRect();
      const anchor = this.$el.getBoundingClientRect();
      this.offsetTop = Math.round(toggle.bottom - anchor.top + 8);
      // Panel sag kenari ikonun sag kenariyla hizalanir. `transform` ile
      // kaydirma YAPILMIYOR: transform tasiyan bir ata, `position: fixed`
      // torunlar icin kapsayici blok olur ve panel icindeki AppDatePicker
      // viewport koordinatlariyla konumlandigi icin yanlis yere duserdi.
      // Capa 0 genislikte, bu yuzden ofset negatif cikar; gecerli.
      this.offsetRight = Math.round(anchor.left - toggle.right);
    },
    // inline modda tam ekran overlay yok; disari tiklama ve ESC burada.
    onDocumentClick(event) {
      if (!this.panelOpen || !this.isDropdownMode) return;
      if (this.$el && this.$el.contains(event.target)) return;
      if (this.toggleEl && this.toggleEl.contains(event.target)) return;
      this.closePanel();
    },
    onDocumentKeydown(event) {
      if (event.key === "Escape" && this.panelOpen && this.isDropdownMode) {
        this.closePanel();
      }
    },
    bindToggle() {
      this.unbindToggle();
      this.toggleEl = this.$el && this.$el.previousElementSibling;
      if (this.toggleEl) {
        this.toggleEl.setAttribute("aria-haspopup", "dialog");
        this.toggleEl.setAttribute("aria-expanded", "false");
        this.toggleEl.addEventListener("click", this.onToggleClick);
      }
    },
    unbindToggle() {
      if (this.toggleEl) {
        this.toggleEl.removeEventListener("click", this.onToggleClick);
        this.toggleEl = null;
      }
    },
    syncToggleState() {
      if (this.toggleEl) {
        this.toggleEl.setAttribute("aria-expanded", this.panelOpen ? "true" : "false");
      }
    },
    onToggleClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.panelOpen = !this.panelOpen;
    },
    closePanel() {
      this.panelOpen = false;
    },
    refreshFilterGrid() {
      this.$nextTick(() => {
        const grid = this.$el && this.$el.querySelector("[uk-grid]");
        if (grid && window.UIkit) {
          window.UIkit.update(grid);
        }
      });
    },
    changeCompany($event) {
      this.filter.company_id = $event;
      this.getValues();
      this.fetchUsersByCompany();
    },
    submitFilter() {
      let filteredData = []
      filteredData = {
        company_id: this.filter.company_id ? this.filter.company_id.id : null,
        branch_id: this.filter.branch_id?.length > 0 ? this.filter.branch_id : null,
        group_id: this.filter.group_id?.length > 0 ? this.filter.group_id : null,
        department_id: this.filter.department_id?.length > 0 ? this.filter.department_id : null,
        region_id: this.filter.region_id?.length > 0 ? this.filter.region_id : null,
        title_id: this.filter.title_id?.length > 0 ? this.filter.title_id : null,
        position_id: this.filter.position_id?.length > 0 ? this.filter.position_id : null,
        corporate_id: this.filter.corporate_id?.length > 0 ? this.filter.corporate_id : null,
        integration_tags: this.filter.integration_tags?.length > 0 ? this.filter.integration_tags : null,
        role_ids: this.filter.role_ids?.length > 0 ? this.filter.role_ids : null,
        show_only_unassigned_users: this.filter.show_only_unassigned_users ? this.filter.show_only_unassigned_users : false,
        assignment_id: this.assignment_id.length > 0 ? this.assignment_id : this.surveyId,
        assignment_ids: this.assignment_id.length > 0 ? this.assignment_id : this.surveyId,
        content_ids: this.content_ids.length > 0 ? this.content_ids : null,
        file_category_ids: this.file_category_ids.length > 0 ? this.file_category_ids : null,
        training_id: this.training_id.length > 0 ? this.training_id : null,
        provider: this.showProviderTrainingFilter && this.filter.provider ? this.filter.provider.id : null,
        from_date: this.selectedDate?.start ? new Date(this.selectedDate?.start).toISOString().split('T')[0] : null,
        to_date: this.selectedDate?.end && this.selectedDate.end !== this.selectedDate.start
            ? new Date(this.selectedDate.end).toISOString().split('T')[0]
            : null,
        user_status: this.filter.user_status,
        competency_ids: this.filter.competency_id,
        user_ids: this.isUserActive && this.user_ids.length > 0
            ? (this.user_ids.some(item => item.id === 'all') ? null : this.user_ids.map(item => item.id))
            : null,
        user_id: this.isUserActive && this.user_ids.length > 0
            ? (this.user_ids.some(item => item.id === 'all') ? null : this.user_ids.map(item => item.id))
            : null,
        assignment_status: this.assignment_id.length > 0
            ? null
            : this.assignmentStatusFilter
      }
      this.$emit('getFilter', filteredData)
      this.closePanel()
    },
    resetFilter() {
      this.assignment_id = [];
      this.surveyId = null;
      this.assignmentStatusFilter = 1;
      this.content_ids = [];
      this.file_category_ids = [];
      if (this.isUserActive) {
        this.user_ids = [];
      }
      this.training_id = [];
      const end = new Date();
      const start = new Date();
      start.setDate(start.getDate() - 7);
      const fmt = (d) => {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${y}-${m}-${day}`;
      };
      this.selectedDate = { start: fmt(start), end: fmt(end) };

      const currentCompanyId = this.filter.company_id;
      this.filter = {
        company_id: currentCompanyId,
        branch_id: [],
        department_id: [],
        region_id: [],
        title_id: [],
        position_id: [],
        corporate_id: [],
        provider: null,
        show_only_unassigned_users: false,
        user_status: 1,
        group_id: [],
        integration_tags: [],
        role_ids: []
      };

      this.$nextTick(() => {
        this.submitFilter();
      });
    },
    refreshUsersByCurrentFilters() {
      if (!this.isUserActive) {
        return;
      }

      if (this.reportAssignment && this.assignment_id?.length > 0) {
        this.fetchUsersByAssignments(this.assignment_id);
        return;
      }

      this.fetchUsersByCompany();
    },
    fetchUsersByAssignments(assignments) {
      if (!this.isUserActive) {
        return;
      }

      if (!this.reportAssignment) {
        return;
      }

      if (!assignments || assignments.length === 0) {
        this.fetchUsersByCompany();
        return;
      }

      const ids = assignments.map(item => item.id);

      const isAllSelected = ids.includes('all');

      this.assignmentLoading = true;

      store
          .dispatch(GET_CATALOG_ITEMS, {
            url: 'api/user',
            filters: {
              per_page: 0,
              sort: 'id',
              order: 'desc',
              fields: 'id,name,surname',
              assignment_id: isAllSelected ? null : ids.join(','),
            },
          })
          .then((response) => {
            if (response && response.status) {
              const results = [
                {
                  id: 'all',
                  name: this.$t('general.all'),
                },
              ];

              (response.data || []).forEach((item) => {
                results.push({
                  id: item.id,
                  name: `${item.name} ${item.surname}`.trim(),
                });
              });

              this.userList = results;
            } else {
              this.userList = [];
            }
          })
          .catch(() => {
            this.userList = [];
          })
          .finally(() => {
            this.assignmentLoading = false;
          });
    },
    fetchUsersByCompany() {
      if (!this.isUserActive) return;

      const companyId = this.filter.company_id?.id;
      if (!companyId) return;

      this.assignmentLoading = true;

      store.dispatch(GET_CATALOG_ITEMS, {
        url: "api/user",
        filters: {
          per_page: 0,
          sort: "id",
          order: "desc",
          fields: "id,name,surname",
          company_id: companyId,
          with_survey_result: this.reportSurvey ? true : null

        },
      })
          .then((response) => {
            if (response && response.status) {
              const results = [{ id: "all", name: this.$t("general.all") }];
              (response.data || []).forEach(u => {
                results.push({ id: u.id, name: `${u.name} ${u.surname}`.trim() });
              });
              this.userList = results;
            } else {
              this.userList = [];
            }
          })
          .finally(() => {
            this.assignmentLoading = false;
          });
    },

    getBranches() {
      this.$store.dispatch(BRANCH_MODULE + '/' + GET_BRANCHES, {
        url: BRANCH_BASE_URL,
        filters: {
          company_id: this.filter.company_id.id
        }
      });
    },
    getGroups() {
      this.$store.dispatch(GROUP_MODULE + "/" + GET_GROUPS, {
        url: 'api/group',
        filters: { all: 'all' }
      });
    },
    getIntegrationOptions() {
      if (!this.showIntegrationFilter) return;

      axios.get('api/widgets', {
        params: { with_user_custom_list: 1, by_user: 1 },
        headers: this.apiHeaders,
      }).then((result) => {
        const options = Array.isArray(result.data) ? [...result.data] : [];

        if (!options.some(option => option.type === 'gofluent')) {
          options.push({ type: 'gofluent', title: 'Go Fluent' });
        }

        this.integrationOptions = options.map(option => ({
          id: option.type,
          name: option.title || option.type_lang || option.type,
        }));
      }).catch(() => {
        this.integrationOptions = [];
      });
    },
    getRoles() {
      if (!this.showRoleFilter) return;

      axios.get('api/roles', {
        params: { company_id: this.filter.company_id?.id },
        headers: this.apiHeaders,
      }).then((result) => {
        const globalRoles = Array.isArray(result.data?.global) ? result.data.global : [];
        const companyRoles = Array.isArray(result.data?.company) ? result.data.company : [];

        this.roleOptions = [...globalRoles, ...companyRoles].map(role => ({
          id: role.id,
          name: role.name,
        }));
      }).catch(() => {
        this.roleOptions = [];
      });
    },
    getDepartments() {
      this.$store.dispatch(DEPARTMENT_MODULE + '/' + GET_DEPARTMENTS, {
        url: DEPARTMENT_BASE_URL,
        filters: {
          company_id: this.filter.company_id.id
        }
      });
    },
    getRegions() {
      this.$store.dispatch(REGION_MODULE + '/' + GET_REGIONS, {
        url: REGION_BASE_URL,
        filters: {
          company_id: this.filter.company_id.id
        }
      });
    },
    getTitles() {
      this.$store.dispatch(TITLE_MODULE + '/' + GET_TITLES, {
        url: TITLE_BASE_URL,
        filters: {
          company_id: this.filter.company_id.id
        }
      });
    },
    getPositions() {
      this.$store.dispatch(POSITION_MODULE + '/' + GET_POSITIONS, {
        url: POSITION_BASE_URL,
        filters: {
          company_id: this.filter.company_id.id
        }
      });
    },
    getInstitutions() {
      this.$store.dispatch(COMPANY_MODULE + '/' + GET_INSTITUTIONS, {
        url: COMPANY_BASE_URL,
        filters: {
          all: "all",
          sort: 'asc',
          order: 'id',
        }
      });
    },
    getCatalogTrainings() {
      this.$store.dispatch(GET_CATALOG_ITEMS, {
        url: '/api/all-training-list',
      }).then((response) => {
        if (response) {
          const items = response.data;
          if (items.length) {
            this.formattedCatalogs = items.map((item) => ({
              id: item.id,
              name: item.name,
            }));
          }
        }
      });
    },

    superAdmin() {
      if (this.user_header === null || !("roles" in this.user_header) || this.user_header.roles.length < 3) {
        return false;
      } else
        return true
    },
    getValues() {
      if (!this.filter.company_id) {
        this.filter.company_id = {
          id: this.userInfo.company_id, name: this.userInfo.company_name
        }
      }
      if (this.filter.company_id) {
        this.getPositions();
        this.getTitles();
        this.getRegions();
        this.getDepartments();
        this.getBranches();
        this.getCatalogTrainings();
        this.getGroups();
        this.getIntegrationOptions();
        this.getRoles();
        this.superAdmin() ? this.getInstitutions() : null
        this.filter.position_id = null;
        this.filter.title_id = null;
        this.filter.region_id = null;
        this.filter.department_id = null;
        this.filter.branch_id = null;
        this.filter.group_id = null;
        this.filter.integration_tags = [];
        this.filter.role_ids = [];
        this.filter.provider = null;
        this.filter.show_only_unassigned_users = false;

      }
    }
  },
  watch: {
    isMobile() {
      this.closePanel();
    },
    panelOpen(isOpen) {
      this.syncToggleState();
      if (isOpen) {
        this.updateOffset();
        this.refreshFilterGrid();
      }
    },
    assignment_id: {
      handler(newVal) {
        this.fetchUsersByAssignments(newVal);
      },
      deep: true,
    },
    user_ids: {
      handler(newVal, oldVal) {
        if (!this.isUserActive) {
          return;
        }

        if (Array.isArray(oldVal) && oldVal.length > 0 && Array.isArray(newVal) && newVal.length === 0) {
          this.refreshUsersByCurrentFilters();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.updateIsMobile();
    window.addEventListener("resize", this.onViewportResize, { passive: true });
    document.addEventListener("click", this.onDocumentClick);
    document.addEventListener("keydown", this.onDocumentKeydown);
    this.$nextTick(() => {
      this.bindToggle();
    });
    this.getValues();
    this.fetchUsersByCompany();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onViewportResize);
    document.removeEventListener("click", this.onDocumentClick);
    document.removeEventListener("keydown", this.onDocumentKeydown);
    this.unbindToggle();
  }
}
</script>
<style scoped>
@import "~vue-multiselect/dist/vue-multiselect.min.css";

.user-filter {
  position: absolute;
  width: 0;
  height: 0;
  overflow: visible;
}

.filter-container {
  padding: 0;
  margin: 0;
}

/* ── Web: ortalanmis modal DEGIL, filtre ikonunun altinda acilan dropdown ──
   `.user-filter` zaten ikonun hemen ardinda duran 0x0 bir capa (position:
   absolute). inline modda overlay `position: static` oldugu icin panel
   dogrudan bu capaya yaslaniyor: `position: fixed` olmadigindan sayfayla
   birlikte kayiyor, modal gibi asili kalmiyor.

   `!important`: AppModal'in `.app-modal--inline` kurallari da !important. */
@media (min-width: 768px) {
  .user-filter:not(.user-filter--nested) ::v-deep .app-modal--inline {
    position: absolute;
    top: var(--filter-offset-top, 8px);
    right: var(--filter-offset-right, 0px);
    z-index: 1100;
    display: flex;
    width: min(720px, calc(100vw - 32px)) !important;
    max-width: none !important;
    flex-direction: column;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    box-shadow: 0 12px 32px rgba(15, 23, 42, 0.18);
  }

  /* Header yok: govde ust kosesi de yuvarlansin */
  .user-filter:not(.user-filter--nested) ::v-deep .app-modal--inline .app-modal-body {
    padding: 16px;
    border-radius: 12px;
  }

  /* Panelin ALT sirasindaki multiselect listeleri asagi acilinca govde
     kaydirmasi tarafindan kirpiliyordu. Dropdown modda ic kaydirma yok;
     listeler cerceve disina tasabiliyor ve vue-multiselect'in kendi
     yon secimi (viewport'a gore multiselect--above) dogru calisiyor. */
  .user-filter:not(.user-filter--nested) ::v-deep .app-modal--inline .app-modal-body {
    max-height: none !important;
    overflow: visible !important;
  }

  .user-filter--nested ::v-deep .app-modal-body {
    overflow-y: auto !important;
    overflow-x: hidden;
  }

  .user-filter-panel {
    padding-bottom: 20px;
  }
}

.user-filter ::v-deep .multiselect {
  position: relative;
}

.user-filter ::v-deep .multiselect__content-wrapper {
  position: absolute;
  z-index: 1000;
  max-height: 300px;
  overflow-y: auto;
}

.user-filter ::v-deep .multiselect--active {
  /* panelin z-index'i 1100; liste onun uzerinde olmali */
  z-index: 1101;
}

.user-filter ::v-deep .multiselect--above .multiselect__content-wrapper {
  bottom: 100%;
  border-bottom: none;
  border-top: 1px solid #e8e8e8;
  border-radius: 5px 5px 0 0;
}

.user-filter ::v-deep .app-modal-overlay {
  z-index: 1100;
}

.user-filter--nested ::v-deep .app-modal-overlay {
  z-index: 1200;
}

.user-filter ::v-deep .app-modal-footer .btn {
  padding: 10px 17px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  line-height: 17px;
}

input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

@media (max-width: 767px) {
  .user-filter:not(.user-filter--nested) ::v-deep .app-modal-overlay {
    padding: 0;
    align-items: stretch;
    justify-content: stretch;
  }

  .user-filter:not(.user-filter--nested) ::v-deep .app-modal {
    width: 100% !important;
    max-width: 100% !important;
    height: 100%;
    min-height: 100%;
    max-height: 100% !important;
    border-radius: 0;
    box-shadow: none;
  }

  .user-filter:not(.user-filter--nested) ::v-deep .app-modal-header {
    border-radius: 0;
  }

  .user-filter:not(.user-filter--nested) ::v-deep .app-modal-body {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .user-filter--nested ::v-deep .app-modal-overlay {
    padding: 16px;
    align-items: center;
    justify-content: center;
  }

  .user-filter--nested ::v-deep .app-modal {
    width: calc(100% - 32px) !important;
    max-width: 720px !important;
    height: auto;
    min-height: 0;
    max-height: 85vh !important;
    border-radius: 14px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  .user-filter--nested ::v-deep .app-modal-header {
    padding: 16px;
    border-radius: 14px 14px 0 0;
  }

  .user-filter--nested ::v-deep .app-modal-body {
    flex: 1;
    min-height: 0;
    padding: 16px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .user-filter-grid > *,
  .user-filter-date {
    width: 100% !important;
  }

  .user-filter-grid h5 {
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.4;
  }

  .user-filter ::v-deep .app-modal-title {
    font-size: 16px;
    line-height: 1.4;
  }

  .user-filter ::v-deep .app-modal-close {
    min-width: 48px;
    min-height: 48px;
  }

  .user-filter ::v-deep .app-date-picker__input {
    min-height: 48px;
  }

  .user-filter ::v-deep .multiselect,
  .user-filter ::v-deep .multiselect__tags,
  .user-filter ::v-deep .custom-multiselect .multiselect__tags {
    min-height: 48px;
    height: auto !important;
  }

  .user-filter ::v-deep .multiselect__single,
  .user-filter ::v-deep .multiselect__placeholder,
  .user-filter ::v-deep .multiselect__input,
  .user-filter ::v-deep .form-control,
  .user-filter ::v-deep input[type="text"],
  .user-filter ::v-deep input[type="search"] {
    font-size: 16px;
    line-height: 1.4;
  }

  .user-filter ::v-deep .app-modal-footer {
    display: flex;
    flex-direction: column-reverse;
    gap: 8px;
  }

  .user-filter ::v-deep .app-modal-footer .btn {
    width: 100%;
    min-height: 48px;
    margin: 0;
    font-size: 16px;
  }

  .user-filter ::v-deep .app-modal-footer .btn:active {
    transform: scale(0.98);
    opacity: 0.85;
  }

  .user-filter ::v-deep .uk-radio {
    width: 20px;
    height: 20px;
  }

  .user-filter ::v-deep .user-status-filter label {
    min-height: 48px;
    font-size: 16px;
  }
}

@media (hover: none) {
  .user-filter ::v-deep .app-modal-footer .btn:hover,
  .user-filter ::v-deep .app-modal-close:hover {
    opacity: 1;
    color: #666;
  }
}

@media (prefers-reduced-motion: reduce) {
  .user-filter ::v-deep .app-modal-footer .btn:active {
    transform: none;
  }
}
</style>

<style>
/* Panel, arac cubugundaki capaya `position: absolute` ile bagli; yani sayfa
   akisinin icinde. Bu yuzden `overflow: hidden` tasiyan bir ata (liste
   karti, sekme govdesi) panelin tasan kismini kirpiyor: liste bosken kart
   kisa kaldigi icin panelin alti kesik goruluyordu.

   Scoped DEGIL: hedefler bu componentin disinda, sayfanin kapsayicilari.
   `.app-modal--inline` yalnizca dropdown modda (masaustu, nested degil) ve
   yalnizca panel ACIKKEN DOM'da bulunur; kural da bu yuzden sadece o anda
   devreye girer, kapaninca kirpma kendiliginden geri gelir. */
.card:has(.user-filter .app-modal--inline),
.company-tabs__content:has(.user-filter .app-modal--inline) {
  overflow: visible !important;
}

/* Allow date picker popup to overflow dropdown boundaries */
.large[uk-dropdown] {
  overflow: visible !important;
}

.large[uk-dropdown] [uk-grid] {
  overflow: visible !important;
}

.multiselect__tag {
  color: white;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  background-color: #3e416d;
}

.multiselect__tag-icon {
  background-color: transparent;
  line-height: 2.2;
}

.multiselect__tag-icon:after {
  color: #fff;
}

.multiselect__tag-icon:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.multiselect__input {
  border: unset !important;
}

.multiselect__tags .multiselect__input {
  border: unset !important;
}
</style>
